// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1eFuI","dragIcon":"SortableItem_dragIcon__UBAps","disabled":"SortableItem_disabled__2L4Fa"};